import { useMemo } from 'react';
import { useUrlParams } from './useUrlParams';

export const useActivationConfig = () => {
  const params = useUrlParams();
  
  const config = useMemo(() => {
    // Priority 1: Self-Serve Upsell
    if (params.hasSelfServeUpsell) {
      return {
        text: "Activate Instant AI - Bundle and Save",
        url: "dashboard.instant.one/instant-ai/onboarding/get-started",
        variant: "self-serve-upsell"
      };
    }
    
    // Priority 2: Has Coupon
    if (params.hasCoupon) {
      return {
        text: "Activate Instant AI",
        url: "dashboard.instant.one/instant-ai/onboarding/get-started",
        variant: "coupon"
      };
    }
    
    // Priority 3: High-value deal (calendar link present means >$4k)
    if (params.calendarLink) {
      return {
        text: "Activate Instant AI - Talk with the team",
        url: params.calendarLink,
        variant: "high-value-csm"
      };
    }
    
    // Default fallback
    return {
      text: "Activate Instant AI - Bundle and Save",
      url: "dashboard.instant.one/instant-ai/onboarding/get-started",
      variant: "default"
    };
  }, [params]);

  return { config, params };
};
